import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import './AboutUsSection.scss';

const AboutUsSection = (props) => {
  // Console 日志：显示接收到的数�?

  // �?props 中提取数�?
  const data = props.fields?.SectionItem || [];

  if (data && Array.isArray(data) && data.length > 0) {
  }

  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  if (!data || !Array.isArray(data)) {
    return null;
  }

  if (data.length === 0) {
    return null;
  }

  return (
    <div className="container about-us-section">
      <div className="about-us-section-inner">
        {data.map((item, index) => {
          const reversed = index % 2 !== 0 ? 'reversed' : '';

          // 确保正确访问Sitecore数据结构
          const itemFields = item?.fields || item;
          const imageUrl = getImageUrl(itemFields?.image);
          const title = itemFields?.title?.value || '';
          const description = itemFields?.description?.value || '';
          const buttonText = itemFields?.buttonText?.value || '';
          const buttonUrl = itemFields?.buttonUrl?.value?.href || '';
          const isComingSoon = itemFields?.isComingSoon?.value || false;

          let actionElement = null;
          if (buttonText) {
            if (isComingSoon) {
              actionElement = <button className="coming-soon">Coming soon</button>;
            } else {
              actionElement = (
                <a href={buttonUrl} className="button">
                  {buttonText}
                </a>
              );
            }
          }

          return (
            <div className={`about-us-section-item ${reversed}`} key={index} data-aos="fade-up">
              <div className="image-wrapper">
                <img src={imageUrl} alt={title} className="image" />
              </div>
              <div className="content">
                <h2 className="title">{title}</h2>
                <div className="description" dangerouslySetInnerHTML={{ __html: description }} />
                {actionElement}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AboutUsSection;
